<template>
  <div class="delivery_order">
    <v-container grid-list-xl fluid>
      <v-layout wrap row>
        <v-flex xs12>
          <Title title="Delivery Order">
            <div slot="widget-content">
              <div>
                <p v-if="errors.length">
                  <v-alert
                    :value="true"
                    color="primary"
                    type="error"
                    dismissible
                    outline
                  >{{ errors }}</v-alert>
                </p>

                <p v-if="pdferrors.length">
                  <v-alert
                    :value="true"
                    color="primary"
                    type="error"
                    dismissible
                    outline
                  >{{ pdferrors }}</v-alert>
                </p>
                <v-layout row wrap>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>
                      <span style="color:#0cabc2">Action</span>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-flex xs3>
                    <v-dialog
                      v-model="new_do_dialog"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition"
                    >
                      <v-btn color="primary" slot="activator">New DO</v-btn>

                      <v-card>
                        <v-toolbar dark color="primary">
                          <v-toolbar-title>New DO</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-btn icon dark @click="new_do_dialog = false">
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-toolbar-items>
                        </v-toolbar>

                        <NewDOForm @update="fetch_do_date_picker()"></NewDOForm>
                      </v-card>
                    </v-dialog>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout wrap row>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>
                      <span style="color:#0cabc2">Previous DO</span>
                    </v-toolbar-title>
                  </v-toolbar>
                  <!-- <v-flex xs3>
                    <v-menu
                      lazy
                      :close-on-content-click="true"
                      v-model="date_box"
                      transition="scale-transition"
                      offset-y
                      full-width
                      :nudge-right="40"
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        label="Date"
                        v-model="date"
                        persistent-hint
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="date" @input="date_box = false" no-title actions></v-date-picker>
                    </v-menu>

                  </v-flex>

                  <v-flex xs3>
                    <v-autocomplete
                      v-model="customer"
                      :items="customerList"
                      item-text="name"
                      item-value="name"
                      label="Customer"
                      persistent-hint
                      small-chips
                    ></v-autocomplete>
                  </v-flex>-->

                  <v-flex xs9></v-flex>
                  <v-flex xs3>
                    <v-autocomplete
                      v-model="customer"
                      :items="customerList"
                      item-text="name"
                      item-value="name"
                      label="Customer"
                      persistent-hint
                      small-chips
                      solo
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex xs9></v-flex>
                  <v-flex xs3>
                    <v-checkbox v-model="checkbox_price" label="print with price"></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                <v-flex xs9></v-flex>
                  <v-flex xs3>
                    <v-autocomplete
                      v-model="currency"
                      :items="currencyList"
                      item-text="name"
                      item-value="value"
                      label="Currency"
                      persistent-hint
                      small-chips
                      solo
                    ></v-autocomplete>
                  </v-flex>

                </v-layout>
                <v-layout wrap row>
                  <v-flex xs6></v-flex>
                  <v-flex xs6>

                    <datepicker ref="datepicker" @update="fetch_do_date_picker()"></datepicker>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex >
                    <div style="text-align:center">
                     <v-progress-circular
                        indeterminate
                        :size="30"
                        color="primary"
                     
                        v-if="do_loading"
                        style="margin-bottom:14px"
                      ></v-progress-circular>

                         <v-pagination
                  v-model="do_list_page"
                  :length="do_list_length"
                ></v-pagination>
                </div>
                  </v-flex>
                </v-layout>
                <v-data-table
                  :headers="headers"
                  :items="do_list_array"
                  :search="customer"
                  :disable-initial-sort="true"
                  hide-actions
                  active-class="highlighted"
                  class="elevation-5"
                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td class="text-xs">
                        <b>{{ props.item.prefix_id }}</b>
                      </td>
                      <td class="text-xs">
                        <b>{{ props.item.created_at }}</b>
                      </td>
                      <td class="text-xs">
                        <b>{{ props.item.customer_name }}</b>
                      </td>
                      <td class="text-xs">{{ props.item.driver_name }}</td>
                      <td class="text-xs">
                        <v-chip
                          outline
                          x-large
                          :color="(props.item.invoice_status == '0' ? '#48b24ff2' : props.item.invoice_status == '1' ? '#ff0000a6' : '#48b24ff2' )"
                        >{{ props.item.invoice_status_name }}</v-chip>
                      </td>

                      <td class="text-xs">
                        <v-btn
                          @click="fetch_sewa_for_print(props.item.id,props.item.created_at,props.item.customer_name)"
                        >print Sewa</v-btn>
                        <v-btn
                          @click="fetch_array_for_print(props.item.id,props.item.created_at,props.item.customer_name,props.item.basket_quantity)"
                        >print DO</v-btn>
                      </td>
                      <td class="text-xs">
                        <v-icon
                          medium
                          color="warning"
                          @click="get_do_detail(props.item.id,props.item.created_at,props.item.customer_id)"
                        >build</v-icon>
                        <v-icon medium color="error" @click="deleteDO(props.item.id)">delete_forever</v-icon>
                      </td>
                    </tr>
                  </template>
                    <v-overlay
                    :absolute="true"
                    :value="true"
                  >
                    <v-btn
                      color="success"
                      @click="overlay = false"
                    >
                      Hide Overlay
                    </v-btn>
                  </v-overlay>
                </v-data-table>
                <v-layout wrap row>
                  <v-flex >
                    <div style="text-align:center">
                     <v-progress-circular
                        indeterminate
                        :size="30"
                        color="primary"
                     
                        v-if="do_loading"
                        style="margin-bottom:14px"
                      ></v-progress-circular>

                         <v-pagination
                  v-model="do_list_page"
                  :length="do_list_length"
                ></v-pagination>
                </div>
                  </v-flex>
                </v-layout>
               

                <v-snackbar v-model="snackbar" :top="true">
                  No Internet Connection
                  <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
                </v-snackbar>
              </div>
            </div>
          </Title>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="do_item_dialog">
      <v-card>
        <v-card-title>
          <span class="headline">DO Details</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <do_table ref="do_table"  @update="fetch_do_date_picker()"></do_table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="do_item_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import Title from "@/components/widget/title";
import NewDOForm from "@/views/Create_delivery_order";
import do_table from "@/components/large_component/do_table";
import datepicker from "@/components/widget/datepicker";
import { stringify } from "querystring";

export default {
  components: {
    //  small_list,
    Title,
    NewDOForm,
    do_table,
    datepicker
  },
  data: () => ({
    currencyList:[{name:'RM',value:"RM"},{name:'SGD',value:"$"}],
    currency:'RM',
    search: "",
    isLoading: true,
    snackbar: false,
    errors: "",
    pdferrors: "",
    refresh: true,
    baseUrl: baseUrl,
    date_now: moment().format("DD-MM-YYYY"),
    start_date: moment()
      .startOf("month")
      .format("YYYY-MM-DD"),
    // start_date: moment().format("YYYY-MM-DD"),

    end_date: moment().format("YYYY-MM-DD"),

    selected_customer_name: "",
    selected_customer_address: "",
    selected_driver_name: "",
    selected_do_id: "",
    VegeLogo: "",
    CheckBox: "",
    date_box: false,
    checkbox_price: false,

    date: moment().format("YYYY-MM-DD"),
    customerList: [],
    customer: "",
    do_item_dialog: false,
    headers: [
      { text: "ID", align: "", value: "prefix_id" },
      { text: "Date", align: "", value: "created_at" },
      { text: "Customer", align: "", value: "customer_name" },
      { text: "Delivery Driver", align: "", value: "driver_name" },
      { text: "Status", align: "", value: "invoice_status_name" },
      { text: "Print", align: "", value: "" },
      { text: "Tool", align: "left", value: "" }
    ],
    do_list_array: [],
    fetched_one_do_array: [],
    do_array_for_print: [],
    sewa_array_for_print: [],
    formatted_array2: [],
    new_do_dialog: false,
    own_basket:"",
    basket_in_quantity:"",
    do_list_page:1,
    do_list_length:1,
    do_loading:false,
  }),

  computed: {},

  watch: {

    customer(){
      this.do_list_page=1;
      this.fetch_do_date_picker();
    }
    ,do_list_page(){
      this.fetch_do_date_picker();

    }
  },

  created() {
    this.getCustomer();

    this.getImageLogo();
    this.fetch_do(this.start_date, this.end_date);
  },

  methods: {
   
    getCustomer() {
      const params = new URLSearchParams();
      params.append("get_customer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_customer.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.customerList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Customer List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    fetch_do_array_driver(do_id, driver_name, customer_name, customer_address) {
      this.selected_customer_name = customer_name;
      this.selected_customer_address = customer_address;
      this.selected_driver_name = driver_name;
      this.selected_do_id = "DO" + do_id;
      const params = new URLSearchParams();
      params.append(
        "getDeliveryOrderDetail_ForDriver",
        "getDeliveryOrderDetail_ForDriver"
      );
      params.append("do_id", do_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.fetched_one_do_array = response.data.data;
            this.pdferrors = "";
            this.generatePDF_for_driver();
          } else if (response.data.error == true) {
            this.pdferrors = response.data.message;
            this.fetched_one_do_array = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    fetch_do_array_customer(do_id) {
      const params = new URLSearchParams();
      params.append(
        "getDeliveryOrderDetail_ForCustomer",
        "getDeliveryOrderDetail_ForCustomer"
      );
      params.append("do_id", do_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.fetched_one_do_array = response.data.data;
            this.pdferrors = "";
            this.generatePDF_for_customer();
          } else if (response.data.error == true) {
            this.pdferrors = response.data.message;
            this.fetched_one_do_array = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
     },
    // intervalFetchData: function() {
    //   setInterval(() => {
    //     this.fetch_do();
    //   }, 500);
    // },
    fetch_do_date_picker() {

      this.fetch_do(this.$refs.datepicker.date1, this.$refs.datepicker.date2);
    },

    fetch_do: function(start_date, end_date) {
      if(this.start_date!==start_date || this.end_date!==end_date){
        this.do_list_page=1;
        this.start_date=start_date;
        this.end_date=end_date;
      }
      this.do_loading=true;
      const params = new URLSearchParams();
      params.append("getDeliveryOrderList", "getDeliveryOrderList");
      params.append("start_date", start_date);
      params.append("end_date", end_date);
      params.append("page", this.do_list_page);
      params.append("search", this.customer);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order2.php",
        data: params
      })
        .then(response => {
          console.log(response);
          console.log('hehe do');
          this.do_loading=false;
          if (response.data.error == false) {
            this.snackbar = false;
            this.do_list_array = response.data.data;
            this.do_list_length = response.data.do_list_length;
            this.errors = "";
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.do_list_array = [];
            this.do_list_length = 1;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    get_do_detail(do_id, do_date, customer_id) {
      this.$refs.do_table.getDOStock(do_id, do_date, customer_id,1);
      this.do_item_dialog = true;
    },

    getImageLogo() { 
      const toDataURL = url =>
        fetch(url)
          .then(response => response.blob())
          .then(
            blob =>
              new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              })
          );

      toDataURL(require("@/assets/image/vege_trading.jpg")).then(dataUrl => {
        this.VegeLogo = dataUrl;
      });

      toDataURL(require("@/assets/image/checkbox.png")).then(dataUrl => {
        this.CheckBox = dataUrl;
      });
    },

    generatePDF_for_customer: function() {
      // image to url

      var doc = new jsPDF();
      doc.addImage(this.VegeLogo, 15, 10, 20, 23);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(37, 15, "JT VEGE Trading Sdn Bhd");

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(37, 20, "15,Jalan Cenderai 10 81750 Masai Johor");
      doc.text(38, 25, "Phone: 07-3875540");
      doc.text(38, 30, "Fax: 07-3875541");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(168, 15, "Date: ");
      doc.text(168, 20, "Driver: ");

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(178, 15, this.date_now);
      doc.setFontSize(12);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(this.selected_driver_name, 22);
      doc.text(182, 20, splitTitle);

      doc.setFontSize(11);
      doc.setFontStyle("normal");
      doc.text(15, 45, "Customer :");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(45, 45, this.selected_customer_name);

      doc.setLineWidth(0.3);
      doc.line(15, 47, 192, 47);
      //// array add check box
      var formatted = [];
      for (var i = 0; i < this.fetched_one_do_array.length; i++) {
        formatted[i] = this.fetched_one_do_array[i];

        this.$set(formatted[i], "checkbox", "");
      }
      //////auto table
      doc.autoTable({
        pageBreak: "auto",
        startY: 50,
        theme: "grid",

        columnStyles: {
          quantity: { halign: "center", fillColor: "#f7f9f9" },
          weight: { halign: "center", fillColor: "#f7f9f9" },
          farmer_name: { halign: "center", fillColor: "#f7f9f9" },
          create_date: { halign: "center", fillColor: "#f7f9f9" }
        },
        columns: [
          { header: " ", dataKey: "index" },
          { header: "Product Name", dataKey: "product_name" },
          { header: "Weight(kg)", dataKey: "customer_weight" },
          { header: "Qty", dataKey: "quantity" },
          { header: "Check", dataKey: "checkbox" },
          { header: "Remark" }
        ],
        body: formatted,

        didDrawCell: data => {
          if (data.section === "body" && data.column.index === 4) {
            var base64Img = this.CheckBox;
            doc.addImage(base64Img, data.cell.x + 5, data.cell.y + 2, 4, 4);
          }

          // if (data.section === "body" && data.column.index === 4) {

          //   toDataURL(
          //     "https://www.gravatar.com/avatar/d50c83cc0c6523b4d3f6085295c953e0"
          //   ).then(dataUrl => {
          //     console.log(this.dataUrl);

          //     this.doc.addImage(dataUrl, data.cell.x + 5, data.cell.y + 2, 4, 4);
          //   });
          // }
        }
      });
      //////after auto table
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.3);
      doc.line(
        15,
        doc.autoTable.previous.finalY + 5,
        192,
        doc.autoTable.previous.finalY + 5
      );

      // doc.setFontSize(12);
      // doc.setFontStyle("normal");
      // doc.text(140, doc.autoTable.previous.finalY + 15, "RECIEVED:");

      // doc.setLineWidth(0.1);
      // doc.line(
      //   140,
      //   doc.autoTable.previous.finalY + 35,
      //   192,
      //   doc.autoTable.previous.finalY + 35
      // );

      // doc.setFontSize(10);
      // doc.setFontStyle("normal");
      // doc.text(140, doc.autoTable.previous.finalY + 40, "Name:");
      // doc.text(140, doc.autoTable.previous.finalY + 46, "Date:");

      // var img = "@/assets/image/broccoli.jpeg";

      doc.save(this.selected_customer_name + "_DO.pdf");
    },

    generatePDF_for_driver: function() {
      // image to url

      var doc = new jsPDF();

      doc.addImage(this.VegeLogo, 15, 10, 23, 23);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      // doc.text(40, 15, "Yofu VEG Trading ");
      doc.text(40, 15, "Mahsing VEG Trading ");

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(41, 20, "443, Jalan Kempas 2, Bandar Putra,81000 Kulai");
      doc.text(41, 25, "Phone: 0127529935 (Mr Mah)");
      doc.text(41, 30, "Fax: -");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(168, 15, "No: ");
      doc.text(168, 20, "Date: ");
      doc.text(168, 25, "Driver: ");

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(175, 15, this.selected_do_id);
      doc.text(178, 20, this.date_now);
      doc.setFontSize(12);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(this.selected_driver_name, 22);
      doc.text(182, 25, splitTitle);

      // doc.font('fonts/msyh.ttf');
      // doc.addFont("msyh-normal.ttf", "msyh", "normal");
      //doc.setFontStyle('msyh');
      doc.setFontSize(13);
      doc.setFontStyle("normal");
      doc.text(15, 45, "Customer:");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(45, 40, this.selected_customer_name);
      doc.setFontStyle("normal");
      doc.text(45, 45, this.selected_customer_address);

      doc.setLineWidth(0.3);
      doc.line(15, 47, 192, 47);
      //// array add check box
      var formatted = [];
      for (var i = 0; i < this.fetched_one_do_array.length; i++) {
        formatted[i] = this.fetched_one_do_array[i];

        this.$set(formatted[i], "checkbox", "");
      }
      //////auto table
      doc.autoTable({
        pageBreak: "auto",
        startY: 50,
        theme: "grid",

        columnStyles: {
          product_name: { columnWidth: 20 },
          grade: { columnWidth: 10 },
          quantity: { columnWidth: 10 },
          single_weight: { columnWidth: 70 },
          5: { columnWidth: 10 }
        },
        columns: [
          { header: " ", dataKey: "index" },
          { header: "Vege", dataKey: "product_name" },
          { header: "Grade", dataKey: "grade" },
          { header: "Qty", dataKey: "quantity" },
          { header: "Basket(kg)/Box", dataKey: "single_weight" },
          { header: "Remark" }
        ],
        body: formatted

        // didDrawCell: data => {
        //   if (data.section === "body" && data.column.index === 6) {
        //     var base64Img = this.CheckBox;
        //     doc.addImage(base64Img, data.cell.x + 5, data.cell.y + 2, 4, 4);
        //   }

        //   // if (data.section === "body" && data.column.index === 4) {

        //   //   toDataURL(
        //   //     "https://www.gravatar.com/avatar/d50c83cc0c6523b4d3f6085295c953e0"
        //   //   ).then(dataUrl => {
        //   //     console.log(this.dataUrl);

        //   //     this.doc.addImage(dataUrl, data.cell.x + 5, data.cell.y + 2, 4, 4);
        //   //   });
        //   // }
        // }
      });
      //////after auto table
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.3);
      doc.line(
        15,
        doc.autoTable.previous.finalY + 5,
        192,
        doc.autoTable.previous.finalY + 5
      );

      // doc.setFontSize(12);
      // doc.setFontStyle("normal");
      // doc.text(140, doc.autoTable.previous.finalY + 15, "RECIEVED:");

      // doc.setLineWidth(0.1);
      // doc.line(
      //   140,
      //   doc.autoTable.previous.finalY + 35,
      //   192,
      //   doc.autoTable.previous.finalY + 35
      // );

      // doc.setFontSize(10);
      // doc.setFontStyle("normal");
      // doc.text(140, doc.autoTable.previous.finalY + 40, "Name:");
      // doc.text(140, doc.autoTable.previous.finalY + 46, "Date:");

      // var img = "@/assets/image/broccoli.jpeg";
      // doc.output(this.selected_driver_name + "_DO.pdf");
      doc.save(this.selected_driver_name + "_DO.pdf");
    },
    fetch_array_for_print(do_id, date, customer_name, basket_quantity) {
      const params = new URLSearchParams();
      params.append("getDOStock", "getDOStock");
      params.append("do_id", do_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.do_array_for_print = response.data.data;
            this.check_own_basket(do_id, date, customer_name, basket_quantity);
            // this.get_basket(do_id, date, customer_name, basket_quantity) ;
            this.print_do(do_id, date, customer_name, basket_quantity);
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.do_array_for_print = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    fetch_sewa_for_print(do_id, date, customer_name) {
      const params = new URLSearchParams();
      params.append("sewa", "sewa");
      params.append("do_id", do_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          console.log("hahaha");

          console.log(response);
          if (response.data.error == false) {
            this.snackbar = false;
            this.sewa_array_for_print = response.data.data;
            // console.log( JSON.stringify( this.sewa_array_for_print));
            if (parseFloat(this.sewa_array_for_print[0].total_weight) > 0) {
              this.print_sewa(do_id, date, customer_name);
            }
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.sewa_array_for_print = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    print_do(do_id, date, customer_name, basket_quantity) {
      var doc = new jsPDF();

      // doc.addImage(this.VegeLogo, 15, 10, 23, 23);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(14, 15, localStorage.name);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(15, 20, localStorage.address);
      doc.text(15, 25, "Phone:" + localStorage.phone);
      doc.text(15, 30, "Fax: -" + localStorage.fax);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(162, 15, "ID: ");
      // doc.text(158, 20, "Date: ");
      doc.text(148, 25, "Customer: ");
      // doc.text(137, 40, "Basket returned: ");

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(170, 15, "#" + do_id);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      // doc.text(170, 20, date);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(customer_name, 30);
      doc.text(170, 25, splitTitle);

      // doc.setFontSize(10);
      // doc.setFontStyle("bold");
      // doc.text(170, 40, basket_quantity);

      doc.setFontSize(11);
      doc.setFontStyle("normal");
      doc.text(15, 45, "Sales Bill:");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(55, 45, date);
      doc.setLineWidth(0.3);
      doc.line(15, 54, 192, 54);

      doc.setLineWidth(0.4);
      doc.line(135, 35, 192, 35);
      doc.line(135, 52, 192, 52);
      doc.line(135, 35, 135, 52);
      doc.line(192, 35, 192, 52);

      doc.setFontSize(10);
      doc.setFontStyle("bold");
      doc.text(138, 42, "B/F:");
      doc.text(158, 42, "OUT:");
      doc.text(138, 48, "IN:");
      doc.text(158, 48, "BALANCE:");



      var out=0;
      for (var i = 0; i < this.do_array_for_print.length; i++) {
        out=out+parseFloat(this.do_array_for_print[i].basket_item_quantity);
      }
      doc.setFontStyle("normal");
      doc.text(167, 42, (isNaN(out)|| out== null?0:out).toString());
      doc.text(147, 42, (isNaN(this.own_basket)|| this.own_basket== null|| this.own_basket== 0 ?'':this.own_basket).toString());


      var inbasket= ( isNaN(this.basket_in_quantity) || this.basket_in_quantity == null ||  this.basket_in_quantity == "" ?0:this.basket_in_quantity).toString();
 
      doc.text(147, 48, (inbasket==0 ?'':inbasket).toString());
      
      var balance =parseFloat((isNaN(this.own_basket)|| this.own_basket== null?0:this.own_basket))+parseFloat((isNaN(out)||out== null?0:out)-parseFloat((isNaN(this.basket_in_quantity)||this.basket_in_quantity== null?0:this.basket_in_quantity)));
      
      doc.text(178, 48, (inbasket==0|| inbasket==null?'':balance).toString());


      this.formatted_array2=[];
      var formatted_array = [];
      var total_amount = 0;
      for (var i = 0; i < this.do_array_for_print.length; i++) {
        formatted_array[i] = this.do_array_for_print[i];

        var sub_total =
          parseFloat(this.do_array_for_print[i].price *
          this.do_array_for_print[i].real_weight *
          this.do_array_for_print[i].quantity).toFixed(2);
        this.$set(
          formatted_array[i],
          "sub_total",
          parseFloat(sub_total).toFixed(2)
        );

        this.$set(formatted_array[i], "row_no", i + 1);
        total_amount = parseFloat(total_amount) + parseFloat(sub_total);
      }

      // console.log(JSON.stringify(formatted_array));

      for (var g = 0; g < formatted_array.length; g++) {
        this.find(
          formatted_array[g].product_name,
          formatted_array[g].grade,
          formatted_array[g].location,
          formatted_array[g].weight,
          formatted_array[g].real_weight,
          formatted_array[g].quantity,
          formatted_array[g].price,
          formatted_array[g].product_id,
          formatted_array[g].sub_total,
          formatted_array[g].basket_item_quantity
        );
        if(g==formatted_array.length-1){
          for(var z=0; z<this.formatted_array2.length; z++){
            
            var split_array = this.formatted_array2[z].weight.split(",");

            if(split_array[0]=='box'){
              this.formatted_array2[z].weight=split_array.length +'box';
            }
            if(split_array[0]=='pkt'){
              this.formatted_array2[z].weight=split_array.length +'pkt';
            }
            if(split_array[0]=='pcs'){
              this.formatted_array2[z].weight=split_array.length +'pcs';
            }
            if(split_array[0]=='bag'){
              this.formatted_array2[z].weight=split_array.length +'bag';
            }

          }
        }
      }

      //////auto table
      var total = 0;
      var nextstart = 0;
      var invoice_pdf_header = [
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Qty", dataKey: "quantity" },
        // { header: "Basket?", dataKey: "basket_used" },
        { header: "Weight", dataKey: "weight" },
        // { header: "Amount", dataKey: "sub_total" }
      ];
      var grade_array = { header: "Grade", dataKey: "grade" };
      var location_array = { header: "Location", dataKey: "location" };
      var price_array = { header: "Price/kg", dataKey: "price" };
      var Amount_array = { header: "Amount", dataKey: "sub_total" };

      // if (localStorage.setting_location == "true") {
      //   invoice_pdf_header.splice(2, 0, location_array);
      // }
      if (localStorage.setting_grade == "true") {
        invoice_pdf_header.splice(2, 0, grade_array);
      }
      if (this.checkbox_price == true) {
        invoice_pdf_header.splice(7, 0, price_array);
        invoice_pdf_header.splice(8, 0, Amount_array);
      }
      for (var i = 0; i < this.formatted_array2.length; i++) {
        this.$set(this.formatted_array2[i], "row_no", i + 1);
      }

      for (var i = 0; i < this.formatted_array2.length; i++) {
        // this.formatted_array2[i].sub_total=parseFloat(this.formatted_array2[i].sub_total).toFixed(2);

        if(this.formatted_array2[i].weight.substring(0,3)=="box"){
          var box_array=[];
          var box_quantity=0;
            box_array=this.formatted_array2[i].weight.split(',');
              for (var c = 0; c < box_array.length; c++) {
                  box_quantity++;
              }
              this.formatted_array2[i].weight=box_quantity+"box";
        }
      }


      doc.autoTable({
        pageBreak: "auto",
        startY: 55,
        theme: "grid",
        showHead: "firstPage",
        didDrawPage: function(data) {
          // Header
          doc.setFontSize(20);
          doc.setTextColor(40);
          doc.setFontStyle("normal");

          // Footer
          var str = "Page " + doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str;
          }
          doc.setFontSize(10);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          doc.text(str, 100, pageHeight - 10);
        },
        headStyles: {
          fillColor: [224, 224, 224],
          textColor: 10,
          fontSize: 11
        },
          styles: {
       
        cellPadding: [2,2,5,2]
        },
        columnStyles: {
          row_no: { columnWidth: 6, fontStyle: "bold" },
          product_name: { columnWidth: 20, fontStyle: "bold" },
          grade: { columnWidth: 4 },
          // location: { columnWidth: 8 },
          weight: { columnWidth: 60,fontSize:9 },
          // basket_used: { columnWidth: 10},
          quantity: { columnWidth: 4, fontStyle: "bold" },
          price: { columnWidth: 7, fontStyle: "normal" },
          sub_total: { columnWidth: 7, fontStyle: "bold" }
        },
        columns: invoice_pdf_header,
        body: this.formatted_array2
      });
      if (this.checkbox_price == true) {
        doc.text(
          155,
          doc.autoTable.previous.finalY + 10,
          "TOTAL: "+this.currency + parseFloat(total_amount).toFixed(2)
        );
      }

      //////after auto table
      if (doc.autoTable.previous.finalY > 230) {
        doc.addPage();
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(15, 20, 192, 20);

        // doc.setFontSize(12);
        // doc.setFontStyle("normal");
        // doc.text(140, 26, "RECIEVED:");

        // doc.setLineWidth(0.1);
        // doc.line(140, 37, 192, 37);

        // doc.setFontSize(10);
        // doc.setFontStyle("normal");
        // doc.text(140, 42, "Name:");
        // doc.text(140, 47, "Date:");

        //  doc.setFontSize(11);
        // doc.setFontStyle("normal");
        // doc.text(15, 31, "Notes:");
        // doc.text(15, 35, "1. All cheques should be crossed and make payable to");
        // doc.setFontStyle("bold");
        // doc.text(19, 40, "MAH SING ENTERPRISE");
        // doc.setFontStyle("bold");
        // doc.text(19, 45, "Bank Account: 3194407617(Public Bank)");
    

        // doc.setFontSize(12);
        // doc.setFontStyle("normal");
        // doc.text(140, 31, "RECIEVED:");


        doc.setLineWidth(0.1);
        doc.line(
          15,
           62,
           77,
           62
        );
        doc.setFontSize(10);
        doc.setFontStyle("bold");
        // doc.text(25, 66, "MAH SING ENTERPRISE");
        doc.text(25, 66, "Yofu Veg Trading");
        doc.line(130, 62, 192, 62);
        doc.setFontSize(10);

        doc.setFontStyle("bold");
        doc.text(133.5, 66, "CUSTOMER SIGNATURE/STAMP");

      } else {
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(
          15,
          doc.autoTable.previous.finalY + 25,
          192,
          doc.autoTable.previous.finalY + 25
        );
        // doc.setFontSize(11);
        // doc.setFontStyle("normal");
        // doc.text(15, doc.autoTable.previous.finalY+31, "Notes:");
        // doc.text(15, doc.autoTable.previous.finalY+35, "1. All cheques should be crossed and make payable to");
        // doc.setFontStyle("bold");
        // doc.text(19, doc.autoTable.previous.finalY+40, "MAH SING ENTERPRISE");
        // doc.setFontStyle("bold");
        // doc.text(19, doc.autoTable.previous.finalY+45, "Bank Account: 3194407617(Public Bank)");

        doc.setLineWidth(0.1);
        doc.line(
          15,
          doc.autoTable.previous.finalY + 62,
          77,
          doc.autoTable.previous.finalY + 62
        );
        doc.setFontSize(10);
        doc.setFontStyle("bold");
        // doc.text(25,  doc.autoTable.previous.finalY +66, "MAH SING ENTERPRISE");
        doc.text(25,  doc.autoTable.previous.finalY +66, "Yofu Veg Trading");

        
        doc.line(
          130,
          doc.autoTable.previous.finalY + 62,
          192,
          doc.autoTable.previous.finalY + 62
        );
        doc.setFontSize(10);
        doc.setFontStyle("bold");
        doc.text(133.5,  doc.autoTable.previous.finalY +66, "CUSTOMER SIGNATURE/STAMP");


        

        // doc.setFontSize(12);
        // doc.setFontStyle("normal");
        // doc.text(140, doc.autoTable.previous.finalY + 31, "RECIEVED:");

        // doc.setLineWidth(0.1);
        // doc.line(
        //   140,
        //   doc.autoTable.previous.finalY + 42,
        //   192,
        //   doc.autoTable.previous.finalY + 42
        // );

        // doc.setFontSize(10);
        // doc.setFontStyle("normal");
        // doc.text(140, doc.autoTable.previous.finalY + 47, "Name:");
        // doc.text(140, doc.autoTable.previous.finalY + 52, "Date:");
      }

      // var img = "@/assets/image/broccoli.jpeg";
      doc.autoTable.previous.finalY = 0;
      invoice_pdf_header = [
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Weight", dataKey: "weight" }
        // { header: "Qty", dataKey: "quantity" },
        // { header: "Amount", dataKey: "sub_total" }
      ];
      doc.save("DO-" + customer_name + "-" + date + ".pdf");
    },
    print_sewa(do_id, date, customer_name) {
      var doc = new jsPDF();

      // doc.addImage(this.VegeLogo, 15, 10, 23, 23);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(14, 15, localStorage.name);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(15, 20, localStorage.address);
      doc.text(15, 25, "Phone:" + localStorage.phone);
      doc.text(15, 30, "Fax: -" + localStorage.fax);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(162, 15, "ID: ");
      doc.text(158, 20, "Date: ");
      doc.text(148, 25, "Customer: ");

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(170, 15, "#DO" + do_id);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(170, 20, date);

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(customer_name, 30);
      doc.text(170, 25, splitTitle);

      doc.setFontSize(11);
      doc.setFontStyle("normal");
      doc.text(15, 45, "Customer Vege Date (Sewa):");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(65, 45, date);
      doc.setLineWidth(0.3);
      doc.line(15, 47, 192, 47);

      this.sewa_array_for_print[0].total_sewa =
        "RM" +
        parseFloat(
          parseFloat(this.sewa_array_for_print[0].total_sewa) > -1
            ? this.sewa_array_for_print[0].total_sewa
            : "0"
        ).toFixed(2);
      this.sewa_array_for_print[0].total_weight =
        (parseFloat(this.sewa_array_for_print[0].total_weight) > -1
          ? this.sewa_array_for_print[0].total_weight
          : "0") + "kg";
      this.sewa_array_for_print[0].sewa_price =
        "RM" + parseFloat(this.sewa_array_for_print[0].sewa_price).toFixed(2);

      //////auto table
      var total = 0;
      var nextstart = 0;
      var invoice_pdf_header = [
        { header: "Total Weight", dataKey: "total_weight" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Price per KG", dataKey: "sewa_price" },
        { header: "Total Amount", dataKey: "total_sewa" }
      ];

      doc.autoTable({
        pageBreak: "auto",
        startY: 55,
        theme: "grid",

        headStyles: {
          fillColor: [224, 224, 224],
          textColor: 10,
          fontSize: 11
        },

        columnStyles: {
          total_weight: { columnWidth: 30 },
          sewa_price: { columnWidth: 30 },
          total_sewa: { columnWidth: 10, fontStyle: "bold", fontSize: 12 }
        },
        columns: invoice_pdf_header,
        body: this.sewa_array_for_print
      });

      //////after auto table

      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.3);
      doc.line(
        15,
        doc.autoTable.previous.finalY + 25,
        192,
        doc.autoTable.previous.finalY + 25
      );

      doc.setFontSize(12);
      doc.setFontStyle("normal");
      doc.text(140, doc.autoTable.previous.finalY + 31, "RECIEVED:");

      doc.setLineWidth(0.1);
      doc.line(
        140,
        doc.autoTable.previous.finalY + 42,
        192,
        doc.autoTable.previous.finalY + 42
      );

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(140, doc.autoTable.previous.finalY + 47, "Name:");
      doc.text(140, doc.autoTable.previous.finalY + 52, "Date:");

      // var img = "@/assets/image/broccoli.jpeg";
      doc.autoTable.previous.finalY = 0;

      doc.save("DO(Sewa)-" + customer_name + "-" + date + ".pdf");
    },
    deleteDO(do_id) {
      if (confirm("Do you really want to delete?")) {
        const params = new URLSearchParams();
        params.append("delete", "1");
        params.append("do_id", do_id);
        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
          data: params
        })
          .then(response => {
            if (response.data.status == "1") {
              this.snackbar_response = true;
              this.response_detail = "delete success";
              console.log(response.data.status);
              this.fetch_do(
                this.$refs.datepicker.date1,
                this.$refs.datepicker.date2
              );
            } else {
              this.snackbar_response = true;
              this.response_detail = "Something Wrong";
            }
          })
          .catch(error => {
            console.log(error);
            this.snackbar_connection = true;
          });
      }
    },
    check_own_basket(do_id, date, customer_name, basket_quantity){
       const params = new URLSearchParams();
      params.append("getCustomerBasketRecordForDO", "getCustomerBasketRecordForDO");
      params.append("do_id", do_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/basket/basket_customer.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            var basket=[];
            basket=response.data.data;
            this.own_basket=basket[0].quantity;
            this.get_basket(do_id, date, customer_name, basket_quantity);

          } else if (response.data.error == true) {
            this.own_basket=0;
            this.get_basket(do_id, date, customer_name, basket_quantity);

          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    find(
      product_name,
      grade,
      location,
      weight,
      real_weight,
      quantity,
      price,
      product_id,
      sub_total,
      basket_item_quantity
      ) {
      console.log(product_name);
      console.log(sub_total);
      var box_quantity=0;
      var vege_quantity=0;
      var basket_used="";
    
      if(parseFloat(basket_item_quantity)>0){
        
        basket_used="Basket";
      } else{
        basket_used="No Basket";
      }
     
      for (var g = 0; g < this.formatted_array2.length; g++) {
        if (
          this.formatted_array2[g].grade == grade &&
          this.formatted_array2[g].location == location &&
          this.formatted_array2[g].product_id == product_id &&
          this.formatted_array2[g].price == price &&
          this.formatted_array2[g].basket_used == basket_used 
        ) {
            
    
          for (var j = 0; j < quantity; j++) {
            this.formatted_array2[g].weight =
              this.formatted_array2[g].weight + "," + weight;

            this.formatted_array2[g].quantity++; 
              


          }

            // this.formatted_array2[g].sub_total =parseFloat(this.formatted_array2[g].sub_total).toFixed(2)

           this.formatted_array2[g].sub_total =
              parseFloat(parseFloat(this.formatted_array2[g].sub_total) +
              parseFloat(sub_total)).toFixed(2);

                this.formatted_array2[g].basket_item_quantity =
              parseFloat(this.formatted_array2[g].basket_item_quantity) +
              parseFloat(basket_item_quantity);
          return;
        }
      }

      var single_weight = "";

      for (var i = 0; i < quantity; i++) {
        single_weight =
          (single_weight == "" ? "" : single_weight + ",") + weight;
      }

      this.formatted_array2.push({
        product_name: product_name,
        grade: grade,
        location: location,
        weight: single_weight,
        real_weight: real_weight,
        quantity: quantity,
        price: price,
        product_id: product_id,
        sub_total: sub_total,
        basket_item_quantity: basket_item_quantity,
        basket_used: basket_used,
      });
    },
    get_basket(do_id, date, customer_name, basket_quantity) {
      const params = new URLSearchParams();
      params.append("readDOBasket", "readDOBasket");
      params.append("do_id", do_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            var quantity = [];
            quantity = response.data.data;

            for (var g = 0; g < quantity.length; g++) {
              var basket_q = quantity[g].quantity;
              this.basket_in_quantity = basket_q;
            }
            this.print_do(do_id, date, customer_name, basket_quantity);

          } else if (response.data.error == true) {
            this.basket_in_quantity = "0";
            this.print_do(do_id, date, customer_name, basket_quantity);

          }
     
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
  },
  mounted() {
    // Run the functions once when mounted
    // Run the intervalFetchData function once to set the interval time for later refresh
    // this.intervalFetchData();
  }
};
</script>

